import React, {useState} from 'react';
import {
  Box,
  Button,
  Divider,
  InputAdornment,
  TextField,
} from '@material-ui/core';

/* ───────── props ───────── */
interface ShareInviteCodeProps {
  /** Full invite URL to display and copy */
  url: string;
  /** Optional plain code if the parent needs it elsewhere */
  inviteCode?: string;
}

const ShareInviteCode: React.FC<ShareInviteCodeProps> = ({
  url,
  inviteCode: _inviteCode, // renamed to satisfy lint rule
}) => {
  const [copied, setCopied] = useState(false);

  /* copy helper */
  const copyTextToClipboard = async (text: string) => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(text);
    } else {
      document.execCommand('copy', true, text);
    }
  };

  const handleCopyClick = () => {
    copyTextToClipboard(url)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(console.error);
  };

  return (
    <Box className="invite-code-share-box">
      <Box className="share-line" display="flex" alignItems="center">
        <TextField
          size="small"
          style={{background: '#fff', width: '24rem'}}
          variant="outlined"
          value={url.toLowerCase()}
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Divider
                  orientation="vertical"
                  style={{height: 28, marginRight: 14}}
                />
                <Button
                  onClick={handleCopyClick}
                  onMouseDown={handleCopyClick}
                  style={{minWidth: 56}}
                >
                  {copied ? 'Copied!' : 'Copy'}
                </Button>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {/* Uncomment if you decide to show the code later
      <Typography variant="caption" color="textSecondary">
        {_inviteCode
          ? `Invite code: ${_inviteCode.toUpperCase()}`
          : 'This is your personal invite link. Copy and share'}
      </Typography>
      */}
    </Box>
  );
};

export default ShareInviteCode;
